'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* TODO.

  <div class="spinner" role="spinner">
    <div class="spinner-icon"></div>
  </div>

*/

var barStyles = {
  position: 'fixed',
  zIndex: 1031,
  top: 0,
  left: 0,
  width: '100%',
  height: '2px'
};

var pegStyles = {
  display: 'block',
  position: 'absolute',
  right: '0px',
  width: '100px',
  height: '100%',
  opacity: 1.0,
  WebkitTransform: 'rotate(3deg) translate(0px, -4px)',
  msTransform: 'rotate(3deg) translate(0px, -4px)',
  transform: 'rotate(3deg) translate(0px, -4px)'
};

var NProgressTemplate = function (_Component) {
  _inherits(NProgressTemplate, _Component);

  function NProgressTemplate() {
    _classCallCheck(this, NProgressTemplate);

    return _possibleConstructorReturn(this, (NProgressTemplate.__proto__ || Object.getPrototypeOf(NProgressTemplate)).apply(this, arguments));
  }

  _createClass(NProgressTemplate, [{
    key: 'render',
    value: function render() {
      var color = this.props.color;


      return _react2.default.createElement(
        'div',
        { className: 'bar',
          role: 'bar',
          style: _extends({}, barStyles, { background: color }) },
        _react2.default.createElement('div', { className: 'peg',
          style: _extends({}, pegStyles, { boxShadow: '0 0 10px ' + color + ', 0 0 5px ' + color }) })
      );
    }
  }]);

  return NProgressTemplate;
}(_react.Component);

NProgressTemplate.propTypes = {
  color: _propTypes2.default.string
};
NProgressTemplate.defaultProps = {
  color: '#29d'
};
exports.default = NProgressTemplate;


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/NProgressTemplate.js
// module id = 1092
// module chunks = 2